import { useState } from 'react';
import { TooltipProps } from './Tooltip.types';

export function Tooltip({
  children = <></>,
  content,
  position = 'bottom',
  delay = 200,
  className = '',
  showArrow = true,
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    const id = setTimeout(() => {
      setIsVisible(true);
    }, delay);
    setTimeoutId(id);
  };

  const handleMouseLeave = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setIsVisible(false);
  };

  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 -translate-x-1/2 mb-[2px]';
      case 'top-right':
        return 'bottom-full left-0 mb-[2px]';
      case 'bottom':
        return 'top-full left-1/2 -translate-x-1/2 mt-[2px]';
      case 'left':
        return 'right-full top-1/2 -translate-y-1/2 mr-[2px]';
      case 'right':
        return 'left-full top-1/2 -translate-y-1/2 ml-[2px]';
      default:
        return 'top-full left-1/2 -translate-x-1/2 mt-[2px]';
    }
  };

  const getArrowClasses = () => {
    switch (position) {
      case 'top':
        return 'top-full left-1/2 -translate-x-1/2 -mt-[1px] border-t-gray-900 border-l-transparent border-r-transparent border-b-transparent';
      case 'top-right':
        return 'top-full left-3 -mt-[1px] border-t-gray-900 border-l-transparent border-r-transparent border-b-transparent';
      case 'bottom':
        return 'bottom-full left-1/2 -translate-x-1/2 -mb-[1px] border-b-gray-900 border-l-transparent border-r-transparent border-t-transparent';
      case 'left':
        return 'left-full top-1/2 -translate-y-1/2 -ml-[1px] border-l-gray-900 border-t-transparent border-b-transparent border-r-transparent';
      case 'right':
        return 'right-full top-1/2 -translate-y-1/2 -mr-[1px] border-r-gray-900 border-t-transparent border-b-transparent border-l-transparent';
      default:
        return 'bottom-full left-1/2 -translate-x-1/2 -mb-[1px] border-b-gray-900 border-l-transparent border-r-transparent border-t-transparent';
    }
  };

  return (
    <div
      className="relative inline-flex"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isVisible && (
        <div
          className={`absolute z-50 ${getPositionClasses()} ${className}`}
          role="tooltip"
        >
          {/* Tooltip Content */}
          <div className="bg-gray-900v2 text-gray-250v2 text-sm rounded px-2 py-1 whitespace-nowrap">
            {content}
          </div>
          {/* Arrow */}
          {showArrow && (
            <div
              className={`absolute w-0 h-0 border-4 ${getArrowClasses()}`}
            />
          )}
        </div>
      )}
    </div>
  );
}

